import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { getLabPanelRows, LabPanelRowData } from "./lab-rows";

export const metadata = {
  tableType: "LaboratoryObservationsPanel",
  displayName: "Lab Panels",
  getRows: (bundle: FhirBundleSdk) => getLabPanelRows({ bundle }).panelRows,
  getSearchableText: (row: Record<string, unknown>) => {
    const panel = row as LabPanelRowData;
    return `${panel.name} ${panel.date}`.toLowerCase();
  },
};
